import { useQuery } from '@tanstack/react-query';

import { createOrderV2Client } from '../api/client';
import { orderV2QueryKeys } from '../api/queryKeys';
import { SkillListItem } from '../api/types';

const useSkills = (billingAccountId: number | null, skillSearch: string) => {
  const enabled = billingAccountId != null;
  const query = useQuery<SkillListItem[]>({
    queryKey: enabled
      ? orderV2QueryKeys.skills(billingAccountId, skillSearch)
      : ['orders_v2', 'skills', 'disabled'],
    queryFn: () =>
      createOrderV2Client
        .listSkills(billingAccountId as number, skillSearch || undefined)
        .then((result) => result || []),
    enabled,
  });

  return {
    skills: query.data ?? [],
    skillsLoading: enabled && query.isFetching,
    skillsError: query.error
      ? (query.error as Error).message || 'Failed to load skills'
      : null,
  };
};

export default useSkills;
